'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _module2 = require('../../module');

var _module3 = _interopRequireDefault(_module2);

var _utils = require('../../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var WinresReservationShoppingTabsDepartureController = function () {
    function WinresReservationShoppingTabsDepartureController($scope, $document, localizationService, $filter) {
        _classCallCheck(this, WinresReservationShoppingTabsDepartureController);

        this.$scope = $scope;
        this.$document = $document;
        this.localizationService = localizationService;
        this.$filter = $filter;
    }

    _createClass(WinresReservationShoppingTabsDepartureController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            // Dependencies
            // this.winresReservationContext

            // Get:
            // getContext()
            // getContext().SelectedDeparture
            // getContext().Destination
            // getContext().Departures

            this.data = this.winresReservationContext.getContext();
            this.$scope.$watch('$ctrl.data', function () {
                if (_this.data.SelectedDeparture) {
                    _this.Departure = _this.data.SelectedDeparture;
                }
                if (_this.data.Destination) {
                    _this.Destination = _this.data.Destination;
                }
            }, true);
        }
    }, {
        key: 'click',
        value: function click() {
            this.winresReservationShoppingTabs.goToPhase('departure');
            //fixes bug in many pages that the page don't scroll down when it should
            if (this.scrollFix === "true") {
                var elem = angular.element('#scroll-anchor-departure');
                if (elem.length) {
                    this.$document.scrollToElement(elem, -300, 1000);
                }
            }
        }

        // gives info about the departure. Custom text (if added to departure data)
        // mode short/long, in short it trunks to number of letter spicified in variable n

    }, {
        key: 'getInfoText',
        value: function getInfoText(mode, n) {
            var text = this.data.Departures["0"].Note;
            if (mode == "long") {
                return text;
            } else if (text.length <= n) {
                return text;
            } else {
                return this.trunk(text, n);
            }
        }
    }, {
        key: 'trunk',
        value: function trunk(str, n) {
            return str.length > n ? str.substr(0, n - 2) + '...' : this;
        }
    }, {
        key: 'isInfoText',
        value: function isInfoText() {
            if (this.data.Departures) {
                try {
                    if (/\S/.test(this.data.Departures["0"].Note)) {
                        return true;
                    }
                } catch (e) {
                    return false;
                }
            }
        }
    }]);

    return WinresReservationShoppingTabsDepartureController;
}();

function getTemplate($attrs, $sce) {
    return $attrs.templateUrl ? $sce.trustAsResourceUrl((0, _utils.getWebcomponentsUrl)($attrs.templateUrl)) : 'shopping-tabs-departure';
}

getTemplate.$inject = ['$attrs', '$sce'];

_module3.default.run(['$templateCache', function ($templateCache) {
    $templateCache.put('shopping-tabs-departure', require('./winresReservationShoppingTabsDeparture.html'));
}]);

WinresReservationShoppingTabsDepartureController.$inject = ['$scope', '$document', 'localizationService', '$filter'];

_module3.default.component('winresReservationShoppingTabsDeparture', {
    templateUrl: getTemplate,
    controller: WinresReservationShoppingTabsDepartureController,
    require: {
        winresReservationContext: '^^winresReservationContext',
        winresReservationShoppingTabs: '^^winresReservationShoppingTabs'
    },
    bindings: {
        title: '@', // replaces the reservation_departure.departures
        button: '@',
        scrollFix: '@',
        hotelMode: '@', // makes the departure & arrival string to work with hotel

        // Show departure flight schedule. false / true.
        flightSchedule: '@'
    }

});


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/winresReservationShoppingTabsDeparture/winresReservationShoppingTabsDeparture.js
// module id = 386
// module chunks = 2